import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-pause.svg'
import _imports_1 from '@/assets/icon-play.svg'


const _withScopeId = n => (_pushScopeId("data-v-1ff96f73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-flex jr-items-end jr-bg-white jr-relative jr-py-2.5" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "pause"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: "play"
}
const _hoisted_4 = { class: "jr-flex-1 jr-mr-10" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-xxs jr--mb-1 jr-ml-1" }, "(%)", -1))
const _hoisted_6 = { class: "bar-container" }
const _hoisted_7 = { class: "progress-container" }
const _hoisted_8 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarChart = _resolveComponent("BarChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["jr-flex jr-justify-center jr-items-center jr-w-6 jr-h-6 jr-rounded-full jr-bg-primary jr-ml-2.5 jr-mb-1", { 'jr-opacity-0': _ctx.captureClip }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePlay && _ctx.handlePlay(...args)))
    }, [
      (_ctx.play)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true),
      (!_ctx.play)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_BarChart, _mergeProps(_ctx.barChartProps, { style: { width: '510px', height: '74px' } }), null, 16),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            id: _ctx.rangeId,
            type: "range",
            class: _normalizeClass(["e-range jr-w-full jr-slider-thumb", { 'jr-pointer-events-none': _ctx.play }]),
            min: 0,
            max: 23,
            step: 1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model) = $event)),
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
          }, null, 42, _hoisted_8), [
            [_vModelText, _ctx.model]
          ])
        ], 512), [
          [_vShow, !_ctx.captureClip]
        ])
      ])
    ])
  ]))
}